import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default class Check extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    input: PropTypes.shape({
      value: PropTypes.bool.isRequired,
      name: PropTypes.string.isRequired,
      onChange: PropTypes.func.isRequired
    }).isRequired
  };

  static defaultProps = {
    icon: "fa-check-circle",
    onChange: () => null
  };

  state = {
    focused: false
  };

  onChange = () => {
    const { input, onChange } = this.props;
    const value = !input.value;

    input.onChange(!!value);
    onChange(!!value);
  };

  onFocus = () => {
    this.setState({ focused: true });
  };

  onBlur = () => {
    this.setState({ focused: false });
  };

  render() {
    const { focused } = this.state;
    const { input, label, icon, disabled, style } = this.props;

    const labelClasses = classNames("btn btn-default", {
      active: input.value,
      focus: focused,
      disabled
    });

    return (
      <label className={labelClasses} htmlFor={input.name} style={style}>
        <input
          type="checkbox"
          id={input.name}
          checked={input.value}
          onChange={this.onChange}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          disabled={disabled}
        />
        <i className={`fa fa-lg ${icon}`} />
        &nbsp;&nbsp;{label}
      </label>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/Check/Check.jsx